import { HiChatBubbleOvalLeftEllipsis } from "react-icons/hi2";

export const GroupChatIcon = ({ width, height, color, ...props }) => (
  <HiChatBubbleOvalLeftEllipsis
    size={width || height || 24}
    color={color || "#5B5B5B"}
    {...props}
  />
);
